import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Button from "../common/Button";
import Spinner from "../Loader";
const ProfileUploadModal = (props) => {
    const isAppLoading = useSelector(state => state.Loader);
    const { onImageUpload, uploadImage,
        show,
        handleClose,
        children,
        isPersonal = false,
        closebutton,
        modalHeading,
        submitButtonTitle,
        onSubmit,
        disabled,
        informationText,
        upperInformationText,
        lowerInformationText,
        retakebuttonTitle,
        onRetake,
        openWebcam,
        uploadedImage,
        SelectdifferentImage,
        size,
    } = props
const error = useSelector(state=>state.ProfileReducer?.typeError)
    return (
        <Modal show={show} onHide={handleClose} className="profile-modal" centered size={size || "bg"}>
            <div className="">
            <div
                closeButton={closebutton}
                className="justify-content-center modal-header"
            >
                <Modal.Title className="modal-title">{modalHeading}</Modal.Title>
                <button type="button" className="btn-close" onClick={handleClose} />
                <p>{informationText &&
                    <p>{(!openWebcam && !uploadedImage) && informationText}</p>
                }
                    {!informationText && (
                        <>
                            <p>
                                {upperInformationText}
                            </p>

                            <p>
                                {lowerInformationText}
                            </p>

                        </>)
                    }</p>
            </div>
            {isAppLoading ? <Spinner show={isAppLoading} /> : (
                <Modal.Body className="">{children}
                    {error?.type==='image' &&<div className="label-error">{error?.message}</div>}
                    {(!openWebcam && !uploadedImage && !props.webcamImage && isPersonal) && <div>
                        <div className="profileModal-note pb-0">
                            <h2>Your photo should:</h2>
                            <ol>
                                <li>Have a clear view of your face (no sunglasses).</li>
                                <li>Have a neutral background.</li>
                            </ol>
                        </div>
                    </div>}
                    <div className="d-flex align-items-center justify-content-center">
                        {retakebuttonTitle && (uploadedImage) && <Link
                            to="#"
                            className="link mx-4"
                            title={retakebuttonTitle}
                            disabled={disabled}
                            onClick={uploadedImage ? SelectdifferentImage : onRetake}
                        >{retakebuttonTitle}</Link>
                        }
                        {(openWebcam && !props.webcamImage) && <Link
                            to="#"
                            className="link mx-4"
                            title='Capture'
                            onClick={(e) => props.onImgCapture()}
                            >Capture</Link>
                        }

                        {submitButtonTitle && (props.webcamImage || uploadedImage) && (
                            <Button
                                title={submitButtonTitle}
                                disabled={disabled}
                                type="button"
                                handleClick={onSubmit}
                            />
                        )}
                    </div>
                </Modal.Body>
            )}
            </div>
        </Modal>

    )
}
ProfileUploadModal.propTypes = {
    show: PropTypes.bool,
    onImageUpload: PropTypes.func,
    openWebcam: PropTypes.bool,
    uploadImage: PropTypes.func,
    size: PropTypes.string
};

ProfileUploadModal.defaultProps = {
    show: false,
    onImageUpload: () => null,
    openWebcam: false,
    uploadImage: () => null,
    size: ''

}
export default ProfileUploadModal